import { useTranslation } from 'react-i18next'

export const LoadingIcon: React.FC = () =>
  <span
    className='material-icons'
    style={{animation: '1.5s linear infinite rotate', fontSize: '42px'}}
  >
    autorenew
  </span>

const LoadingView: React.FC<{show_label?: boolean}> = ({show_label = true}) => {
  const {t} = useTranslation()

  return <div style={{flexGrow: 1, textAlign: 'center', alignContent: 'center'}}>
    <LoadingIcon/>
    {show_label && <>
      <br/>
      {t('general.loading')}
    </>}
  </div>
}

export default LoadingView
